import "./view.scss"

function initLatestPostVideos() {
  const posts = document.querySelectorAll(".wp-block-blueprint-latest-post .Post");
  
  if (!posts) return;
  
  posts.forEach(function(post) {
    const videoPlayer = post.querySelector(".video-player[data-video-id]");
    
    if (!videoPlayer) return;
    
    const videoId = videoPlayer.dataset.videoId;
    if (!videoId) return;
    
    // Check if Vimeo library is available
    if (typeof Vimeo === 'undefined' || !Vimeo.Player) {
      console.warn('Vimeo.Player is not available');
      return;
    }
    
    // Initialize Vimeo background video player
    const vimeo = new Vimeo.Player(videoPlayer, {
      background: true,
      dnt: true,
      id: videoId,
      width: 1920,
      height: 1080,
    });
    
    // Mute video
    vimeo.setVolume(0);
    
    const playButton = post.querySelector(".video-play-button");

    const setPlayButtonLabel = function(label) {
      if (playButton) {
        playButton.setAttribute("aria-label", label);
      }
    };

    // Auto-play video
    vimeo.ready().then(function() {
      const iframe = videoPlayer.querySelector("iframe");
      if (iframe) {
        iframe.setAttribute("tabindex", "-1");
        iframe.setAttribute("aria-hidden", "true");
        iframe.setAttribute("title", "Background video");
      }
      videoPlayer.setAttribute("aria-hidden", "true");

      vimeo.play();
      
      // Hide thumbnail when video starts playing
      const thumbnail = post.querySelector(".video-thumbnail");
      if (thumbnail) {
        thumbnail.style.opacity = "0";
        thumbnail.style.transition = "opacity 0.5s ease-in-out";
      }
    });
    
    // Handle video events
    vimeo.on("play", function() {
      const thumbnail = post.querySelector(".video-thumbnail");
      if (thumbnail) {
        thumbnail.style.opacity = "0";
      }
      post.classList.add("video-playing");
      setPlayButtonLabel("Pause video");
    });
    
    vimeo.on("pause", function() {
      const thumbnail = post.querySelector(".video-thumbnail");
      if (thumbnail) {
        thumbnail.style.opacity = "1";
      }
      post.classList.remove("video-playing");
      setPlayButtonLabel("Play video");
    });

    if (playButton) {
      playButton.addEventListener("click", function(event) {
        event.preventDefault();
        event.stopPropagation();

        vimeo.getPaused().then(function(isPaused) {
          if (isPaused) {
            vimeo.play();
          } else {
            vimeo.pause();
          }
        });
      });
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initLatestPostVideos();
});
